import { shade, tint } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { useObserver, useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { useResolve } from '../../Container';
import { PopperButtonProps, PopperWithCustomOpen } from '../../canvas/ui/Popper';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { HelpController } from './HelpController';
import { HelpLibraryView } from './HelpLibraryView';
import { HelpTipMount } from './HelpTip';

const ButtonFrame = styled.div<{ active: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: ${tint(.1, Colors.mystery)};
    color: white;
    cursor: pointer;
    user-select: none;

    &:hover {
        background: ${Colors.mystery};
    }
    ${p => p.active && css`
        background: ${Colors.mystery};
    `}
    &:active {
        background: ${shade(.2, Colors.mystery)};
    }
`;

const ButtonBubble = styled.div<{ show: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${Colors.observe};
    position: absolute;
    top: -8px;
    right: -8px;
    font-weight: 500;
    font-size: 15px;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    opacity: 0;
    transform: scale(.8);
    pointer-events: none;
    transition: all 100ms ease-in-out;

    ${p => p.show && css`
        opacity: 1;
        transform: scale(1);
    `};
`;

const Button = (props: PopperButtonProps) => {
    const { recommendedVideos } = useObserver(useResolve(HelpController));
    return <ButtonFrame {...props}>
        <Icon src="deqo://icons/deqo/haug-mortarboard" size="2" />
        <ButtonBubble show={recommendedVideos.length > 0}>{recommendedVideos.length}</ButtonBubble>
    </ButtonFrame>;

};

export const HelpButton = () => {

    const ctrl = useObserverReturningStore(useResolve(HelpController));
    const open = ctrl.libraryOpen;
    const setOpen = (value: boolean) => {
        if (value) {
            ctrl.openLibrary();
        }
        else {
            ctrl.closeLibrary();
        }
    };

    return <Flexer absolute right="20px" bottom="80px">
        <HelpTipMount name="videos" placement="left-end">
            <PopperWithCustomOpen
                placement="left-end"
                inner={{ direction: 'left', offset: '.5rem' }}
                button={Button}
                content={HelpLibraryView}
                open={open}
                setOpen={setOpen}
            />
        </HelpTipMount>
    </Flexer>;
};
